import { useState, useEffect } from 'react';
import { employeesAPI } from '../api/employees';

export function useEmployees(filterStatus = 'todos') {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadEmployees();
  }, [filterStatus]);

  const loadEmployees = async () => {
    try {
      setLoading(true);
      const response = await employeesAPI.getAll({ 
        estado: filterStatus === 'todos' ? undefined : filterStatus 
      });
      
      // Handle different response formats
      setEmployees(response.employees || response.data || response || []);
      setError(null);
    } catch (err) {
      console.error('Error loading employees:', err);
      setError(err.message);
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  };

  const reload = () => {
    loadEmployees();
  };

  return {
    employees,
    loading,
    error,
    reload,
    loadEmployees
  };
}

export default useEmployees;
